import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DISMISS_KEY = "summerClosureBannerDismissedAt";
const DISMISS_DAYS = 3;
// Visible from now until the end of the closure
const SHOW_UNTIL = new Date("2026-08-31T23:59:59+02:00");

export const SummerClosureBanner = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (new Date() > SHOW_UNTIL) return;
    try {
      const dismissed = parseInt(localStorage.getItem(DISMISS_KEY) || "0", 10);
      if (Date.now() - dismissed < DISMISS_DAYS * 24 * 3600 * 1000) return;
    } catch (e) { /* ignore */ }
    setOpen(true);
  }, []);

  if (!open || pathname.startsWith("/gestione")) return null;

  const dismiss = () => {
    setOpen(false);
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { /* ignore */ }
  };

  return (
    <div
      className="relative bg-amber-400 text-black px-4 py-2.5 text-center text-sm leading-snug shadow-md z-[70]"
      data-testid="summer-closure-banner"
    >
      <span className="inline-flex items-center gap-1 bg-black text-amber-400 font-bold text-[11px] tracking-wide px-2 py-0.5 rounded mr-2 align-middle uppercase">
        ⛱️ Chiusura estiva
      </span>
      <span className="font-semibold">Dal 1° al 30 agosto siamo in ferie.</span>{" "}
      <span>
        Puoi comunque ordinare: gli ordini di agosto saranno spediti{" "}
        <strong>tra il 10 e il 18 agosto</strong>, poi regolarmente{" "}
        <strong className="text-red-700">dal 1° settembre</strong>.
      </span>
      <button
        onClick={dismiss}
        aria-label="Chiudi avviso chiusura estiva"
        className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-black/80 text-amber-400 text-sm font-bold hover:bg-black"
        data-testid="summer-closure-dismiss"
      >
        ×
      </button>
    </div>
  );
};

export default SummerClosureBanner;
